import React from "react";
import { Table } from "semantic-ui-react";
import BotonBorrar from "../../../../shared/botones/BotonBorrar";

function TableRow(props) {
  const handleRowClick = () => props.handleClick(props.item.id);

  return (
    <Table.Row onClick={handleRowClick}>
      <Table.Cell>{props.item.nombre}</Table.Cell>
      <Table.Cell>{props.item.poblacion}</Table.Cell>
      <Table.Cell>{props.item.provincia}</Table.Cell>
      <Table.Cell>
        <BotonBorrar
          data={{ key: props.item.id }}
          handleClick={props.handleBorrarLinea}
          headerText={`Borrar Colegio de la lista`}
          content={`¿Desea eliminar el colegio ${props.item.nombre}
    de la lista?`}
        />
      </Table.Cell>
    </Table.Row>
  );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/pages/escuelas/buscadores/colegios/tablaColegiosEscuelas/TableRow.jsx